import { put } from 'core/middlewares/utilities';
import { cart as cartSelectors, combo as comboSelectors } from '../../helpers/selectors';
import { cart, combo } from 'core/use-cases';
import { resetProducts } from './reset-products-shipping-model-changes';
import { getLocationPathname } from 'core/utilities';

export function* itemAndComboAdd() {
  const comboPayload: comboSelectors.ComboData = yield comboSelectors.getComboData();
  const pathname = getLocationPathname();
  if (comboPayload.comboCode) {
    yield put(combo.actions.comboPost.request(comboPayload));

    return;
  }

  const itemUpdate: cartSelectors.CartMetaItemUpdate = yield cartSelectors.getCartMetaItemUpdate();

  yield put(cart.actions.itemAddFetch.request(itemUpdate));

  if (!pathname.includes('/produto/')) {
    yield resetProducts();
  }
}
